import React from "react";
import "./cover-services.scss";
import GlobalContext from "../../../contexts/globalContext";
import { GatsbyImage } from "gatsby-plugin-image";
import { findRel } from "../../../shared/utils/stringUtilities";
import Button from "../button/button";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
export interface PropsCover {
  coverData: any;
}
const CoverServices = (props: PropsCover) => {
  const {
    imagenHeader,
    tituloBoton,
    tituloPrincipal,
    descripcion,
    redireccionBoton,
  } = props.coverData;

  const isHttp = (url?: string) => {
    return url?.startsWith("http");
  };

  const raw = JSON.parse(descripcion.raw);

  return (
    <GlobalContext.Consumer>
      {(data) => (
        <div className="as-banner">
          <div className="as-banner-container">
            <div className="position-relative">
              <GatsbyImage
                className="as-fit_img"
                image={imagenHeader.gatsbyImageData}
                alt={
                  imagenHeader.title ? imagenHeader.title : "Cover Servicios"
                }
              />
              <div className="container">
                <div className="as-cover-desc">
                  <a
                    href={redireccionBoton}
                    target={isHttp(redireccionBoton) ? "_blank" : "_self"}
                    rel={findRel(redireccionBoton)}
                  >
                    {descripcion &&
                      raw.content[0]?.content[0]?.content[0]?.content[0].value}
                  </a>
                  <h1 className="as-cover-h1 title-primary">
                    {tituloPrincipal}
                  </h1>
                  {tituloBoton ? (
                    <Button
                      type="button"
                      text={tituloBoton}
                      classname={`primary __mobilecolor as-button ${
                        data.gigyaContext.gigyaAccount
                          ? "hide-button"
                          : "show-button"
                      }`}
                      gtmMark={`gtmRedDeAmorBannerServicio${normalizeTwoWords(
                        tituloBoton
                      )}`}
                      isDisabled={false}
                      onClickAction={data.gigyaContext.login}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className="as-cover-foot hide-on-mobile">
              <div className="container">
                <p>
                  <strong>
                    {descripcion &&
                      raw.content[0]?.content[1]?.content[0]?.content[0]?.value}
                  </strong>
                  |
                  <span>
                    {descripcion &&
                      raw.content[0]?.content[1]?.content[0]?.content[2]?.value}
                  </span>
                </p>
                <div className="lineaServices" />
                <span>
                  {descripcion &&
                    raw.content[0]?.content[2]?.content[0]?.content[0]?.value}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </GlobalContext.Consumer>
  );
};

export default CoverServices;
